import { ChildrenBlock } from '@smartfire/js-block-engine';
import { BrowserRouter } from 'react-router-dom';
import MotionLazyContainer from '../components/animate/MotionLazyContainer';

import ThemeProvider from '../theme';
import ThemeColorPresets from '../components/ThemeColorPresets';
import ThemeLocalization from '../components/ThemeLocalization';
import { useContext, createContext } from 'react';

const AppContext = createContext();

export default function MinimalWrapper({ children }) {
    const appContext = useContext(AppContext);
    const nested = children ? children : [<ChildrenBlock key="children" />];

    if (appContext) return nested;
    else {
        return (
            <AppContext.Provider value={{ isFirstLevel: true }}>
                <BrowserRouter>
                    <ThemeProvider>
                        <ThemeColorPresets>
                            <ThemeLocalization>
                                <MotionLazyContainer>{nested}</MotionLazyContainer>
                            </ThemeLocalization>
                        </ThemeColorPresets>
                    </ThemeProvider>
                </BrowserRouter>
            </AppContext.Provider>
        );
    }
}
